import type { User } from './types';

type AccessSubject = Pick<User, 'role' | 'userGroup'>;

export function isSuperuser(user: Pick<User, 'userGroup'>): boolean {
  return user.userGroup === 'SUPERUSER';
}

export function canManageAdministration(user: AccessSubject): boolean {
  return user.role === 'admin' || isSuperuser(user);
}

export function canUseUserFeedback(user: AccessSubject): boolean {
  return !canManageAdministration(user);
}

export function canReviewFeedback(user: AccessSubject): boolean {
  return canManageAdministration(user);
}
